import LaunchIcon from '@mui/icons-material/Launch'
import { Link } from '@mui/material'

interface Props {
  href: string
  text: string
  textStyle?: object
}

const TextStyle = () => ({
  textDecoration: 'underline',
})

export const LaunchLink = ({ href, text, textStyle = {} }: Props) => {
  return (
    <Link href={href} target="_blank" underline="hover">
      <span style={{ ...TextStyle(), ...textStyle }}>{text}</span>
      <LaunchIcon style={{ paddingLeft: 5, verticalAlign: 'middle' }} />
    </Link>
  )
}
